module.exports = __webpack_public_path__ + "img/survey-form-review-policy-campaign.2be79eb2.png";